import { useState } from 'react';
import { useCalendar } from '../contexts/CalendarContext';
import { useSession } from '../contexts/SessionContext';
import { useBranding } from '../contexts/BrandingContext';
// CIN-6879: the address formatter moved to src/utils/address.js so the modal
// header (which is the only address a Reserve with Google landing page shows,
// since those URLs pin a location and skip this step) and this list can never
// drift apart. Rendered output here is unchanged.
import { formatAddressLines } from '../utils/address';

const LocationSelection = () => {
  const { locations } = useCalendar();
  const { selectedLocation, setSelectedLocation } = useSession();
  const { variant } = useBranding();
  const [searchTerm, setSearchTerm] = useState('');

  // Filter locations based on search term
  const filteredLocations = locations.filter(location => {
    if (!searchTerm) return true;
    
    const searchLower = searchTerm.toLowerCase();
    const searchableFields = [
      location.name,
      location.address1,
      location.address2,
      location.city,
      location.state,
      location.zip_code,
      location.country
    ];
    
    return searchableFields.some(field => 
      field && field.toString().toLowerCase().includes(searchLower)
    );
  });

  return (
    <div className="step-content">
      {(variant === 'v2' || variant === 'v1') && (
        <div className="search-container" style={{ marginBottom: '20px' }}>
          <input
            type="text"
            placeholder="Search locations by name, address, city, or zip..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: 'calc(100% - 4px)', /* Account for border width */
              padding: '12px 16px',
              border: '2px solid #e0e0e0',
              borderRadius: '8px',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.2s',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => e.target.style.borderColor = 'var(--primary-color)'}
            onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
          />
        </div>
      )}
      <div className="locations-list">
        {filteredLocations.length === 0 && searchTerm ? (
          <div style={{
            textAlign: 'center',
            padding: '40px 20px',
            fontStyle: 'italic'
          }} className="caption">
            No locations found matching "{searchTerm}"
          </div>
        ) : (
          filteredLocations.map((location, index) => {
          const addressLines = formatAddressLines(location);
          return (
            <div
              key={location.id || index}
              className={`location-item ${selectedLocation?.id === location.id ? 'selected' : ''}`}
              onClick={() => setSelectedLocation(location)}
            >
              <h3>{location.name}</h3>
              {addressLines.map((line, lineIndex) => (
                <p key={lineIndex} className="body-text">{line}</p>
              ))}
            </div>
          );
        })
        )}
      </div>
    </div>
  );
};

export default LocationSelection;